export const aboutData = {
    title: "Who I am",
    description1: "I'm Umesh Kumar Mishra, a Software Engineer based in Bangalore, India, with nearly 5 years of experience building scalable web and mobile applications across enterprise and product-driven environments.",

    description2: "Started as a full stack developer and gradually evolved into building scalable architectures using React JS, React Native, Next.js, PHP, and modern frontend ecosystems. Passionate about AI-driven products, system design, and creating high-performance digital experiences.",

    image: 2
}